module.exports = __webpack_public_path__ + "media/alarm.abd8c13a.ogg";